/**
 * This component can be used whenever you need a clickable element that isn't
 * visually similar to a button. This can be used when you have a <div> that
 * needs to be clickable. The benefit is a11y: it's tab-selectable, has a focus
 * indicator, etc.
 */
import styled from "styled-components";

export const UnstyledButton = styled.button`
  display: block;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-size: inherit;
`;
